export function formatContact(contact: string) {
    let formattedContact = '';
    const contactChunks = contact.substring(1).replace('.', ' ').split(' ');
    contactChunks?.map(chunk => {
        formattedContact = `${formattedContact} ${chunk}`;
        return undefined;
    });
    return `+${formattedContact}`;
}
